// People a post may @-mention: every personal LinkedIn account connected in
// the post's Supergrow 2.0 org. The server decides the list; the editor only
// shows it and sends back the chosen id.
export const createGetMentionableAccountsRequest = () => {
  return {
    url: "/mentionable_accounts",
    method: "GET",
    disableLoading: true,
  };
};

export const createGetOrgWorkspaceMentionableAccountsRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/mentionable_accounts`,
    method: "GET",
    disableLoading: true,
  };
};
